import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.form.labelFilledColor,
    fontSize: theme.typography.pxToRem(10),
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& .react-tel-input': {
      '& .flag-dropdown': {
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '& .selected-flag': {
          backgroundColor: 'transparent',
          paddingLeft: 16,
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '& .country-list': {
            width: 250,
          },
        },
      },
      '& .form-control': {
        border: 'none',
        borderBottom: '1px solid #777777',
        borderRadius: 0,
        color: theme.palette.text.primary,
        height: 30.63,
        width: '100%',
      },
    },
  },
  errorMsg: {
    fontSize: theme.typography.pxToRem(12),
    marginLeft: 16,
  },
}));

export default useStyles;
